import React, { createContext, useReducer, useContext, useCallback, useMemo, useRef } from "react";
import { vesselVesselContractReducer } from "./vesselVesselContractReducer";
import { initialStore } from "./initialStore";
import * as actionTypes from "./actionTypes";

export const VesselVesselContractContext = createContext(null);

export function VesselVesselContractProvider({ children, initialState = {} }) {
  const [state, dispatch] = useReducer(vesselVesselContractReducer, {
    ...initialStore,
    ...initialState,
  });

  const stateRef = useRef(state);
  stateRef.current = state;

  const setCalculatorData = useCallback((payloadOrUpdater) => {
    const payload =
      typeof payloadOrUpdater === "function"
        ? payloadOrUpdater(stateRef.current.calculatorData)
        : payloadOrUpdater;
    dispatch({ type: actionTypes.SET_CALCULATOR_DATA, payload });
  }, []);

  const setSelectedVessels = useCallback(
    (payload) => dispatch({ type: actionTypes.SET_SELECTED_VESSELS, payload }),
    []
  );

  const setPortOperations = useCallback(
    (payload) => dispatch({ type: actionTypes.SET_PORT_OPERATIONS, payload }),
    []
  );

  const setFleetList = useCallback(
    (payload) => dispatch({ type: actionTypes.SET_FLEET_LIST, payload }),
    []
  );

  const setSelectedQuery = useCallback(
    (payload) => dispatch({ type: actionTypes.SET_SELECTED_QUERY, payload }),
    []
  );

  const setSyncBunker = useCallback(
    (payload) => dispatch({ type: actionTypes.SET_SYNC_BUNKER, payload }),
    []
  );

  const setIsOverride = useCallback(
    (payload) => dispatch({ type: actionTypes.SET_IS_OVERRIDE, payload }),
    []
  );

  const setPortDistanceResponse = useCallback(
    (payload) => dispatch({ type: actionTypes.SET_PORT_DISTANCE_RESPONSE, payload }),
    []
  );

  const setRealPortDistanceResponse = useCallback(
    (payload) => dispatch({ type: actionTypes.SET_REAL_PORT_DISTANCE_RESPONSE, payload }),
    []
  );

  const setPortDistancePayloadResponse = useCallback(
    (payload) => dispatch({ type: actionTypes.SET_PORT_DISTANCE_PAYLOAD_RESPONSE, payload }),
    []
  );

  const setVesselOutContract = useCallback(
    (payload) => dispatch({ type: actionTypes.SET_VESSEL_OUT_CONTRACT, payload }),
    []
  );

  const setRawEstimateContract = useCallback(
    (payload) => dispatch({ type: actionTypes.SET_RAW_ESTIMATE_CONTRACT, payload }),
    []
  );

  const setIsPrivate = useCallback(
    (payload) => dispatch({ type: actionTypes.SET_IS_PRIVATE, payload }),
    []
  );

  const resetStore = useCallback(
    () => dispatch({ type: actionTypes.RESET_STORE }),
    []
  );

  const value = useMemo(
    () => ({
      ...state,
      dispatch,
      setCalculatorData,
      setSelectedVessels,
      setPortOperations,
      setFleetList,
      setSelectedQuery,
      setSyncBunker,
      setIsOverride,
      setPortDistanceResponse,
      setRealPortDistanceResponse,
      setPortDistancePayloadResponse,
      setVesselOutContract,
      setRawEstimateContract,
      setIsPrivate,
      resetStore,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state]
  );

  return (
    <VesselVesselContractContext.Provider value={value}>
      {children}
    </VesselVesselContractContext.Provider>
  );
}

export function useVesselVesselContractContext() {
  const context = useContext(VesselVesselContractContext);
  if (!context) {
    throw new Error(
      "useVesselVesselContractContext must be used within a VesselVesselContractProvider"
    );
  }
  return context;
}
